import Dropdown from "../../components/Dropdown/Dropdown"
import { useEffect, useState } from "react"
import { StorageGetItem, USER } from "../../lib/storage"

// WS #2346323: `lowerFloor` starts every rep's list at 15% (Modern Financial, Solar: Kyle's bigger debts).
// The caller decides it: flag PROGRAM_FEE_FLOOR_15 and an office that permits a flat fee, the offices
// where the server does not check the % range (vlg-api services/users/newLeadDetails.js validateProgramFee).
export const programFeeRange = ({ role, isAffiliateManager = false, lowerFloor = false }) => {
  if (role === 'customer') return { min: 0, max: 50 }
  if (lowerFloor) return { min: 15, max: 50 }
  if (isAffiliateManager || role === 'affiliateGroupsAdmin') return { min: 20, max: 50 }
  return { min: 30, max: 50 }
}

export const programFeeValues = (params) => {
  const { min, max } = programFeeRange(params)
  return Array.from({ length: max - min + 1 }, (_, i) => i + min)
}

export const ProgramFee = ({ value, setValue, classes = '', disabled = false, lowerFloor = false }) => {
  const [userRole, setUserRole] = useState('')
  const [isAffiliateManager, setIsAffiliateManager] = useState(false)
  
  useEffect(() => {
    StorageGetItem(USER).then(result => {
      setUserRole(result?.role)
      setIsAffiliateManager(result?.isAffiliateManager || false)
    })

  }, [])

  const programFeeMenu = programFeeValues({ role: userRole, isAffiliateManager, lowerFloor }).map(fee => ({
    label: ` ${fee}%`,
    value: fee
  }))

  return (
    <>
      <Dropdown
        value={value}
        setValue={setValue}
        menuItems={programFeeMenu}
        className={classes}
        variant="standard"
        placeholder="%"
        label="Program Fee:"
        disabled={disabled}
      />
    </>
  )
}
